import store from "../../store/index";
import EmailRequests from "./EmailRequests";

/** =========== EMAIL MANAGER =========== **/

export const createNewEmail = async function() {
  const creatorId = store.state.auth.user._id;
  const response = await EmailRequests.createNewEmail(creatorId);
  if (response && response.data && response.data.email) {
    const email = response.data.email;
    const emailId = email._id;
    return emailId;
  }
};
export const addNewBlock = async function(emailId, latestIndex) {
  const creatorId = store.state.auth.user._id;
  const response = await EmailRequests.addNewBlock(creatorId, emailId, latestIndex);
  if (response && response.data && response.data.block) {
    const block = response.data.block;
    return block;
  }
};

export const addNewSubblock = async function(blockId, latestIndex) {
  const creatorId = store.state.auth.user._id;
  const response = await EmailRequests.addNewSubblock(creatorId, blockId, latestIndex);
  if (response && response.data && response.data.subblock) {
    const block = response.data.subblock;
    return block;
  }
};

export const deleteBlock = async function(blockId) {
  const response = await EmailRequests.deleteBlock(blockId);
  if (response && response.data && response.data.success) {
    console.log("@deleteKanban: Deleting Block successsful.");
  } else {
    console.log("@deleteKanban: Deleting Block failed.");
  }
};

export const updateBlockData = async function(block) {
  const response = await EmailRequests.updateBlockData(block);
  if (response && response.data && response.data.block) {
    const block = response.data.block;
    return block;
  }
};

export const updateBlockIndexes = async function(blockIndexesData) {
  const response = await EmailRequests.updateBlockData(blockIndexesData);
  if (response && response.data && response.data.success) {
    console.log("@updateBlockIndexes: Successfully updated block indexes.");
  }
};

export const getEmail = async function(emailId) {
  const response = await EmailRequests.getEmail(emailId);
  if (response && response.data && response.data.email) {
    const email = response.data.email;
    return email;
  }
};

export const getEmailBlocks = async function(emailId) {
  const response = await EmailRequests.getEmailBlocks(emailId);
  if (response && response.data && response.data.emailBlocks && response.data.emailBlocks.length) {
    const emailBlocks = response.data.emailBlocks;
    return emailBlocks;
  } else {
    return 1;
  }
};

export const getAllEmails = async function() {
  const response = await EmailRequests.getAllEmails();
  if (response && response.data && response.data.emails) {
    const emails = response.data.emails;
    return emails;
  }
};

export const updateEmailData = async function(email) {
  const response = await EmailRequests.updateEmailData(email);
  if (response && response.data && response.data.email) {
    const email = response.data.email;
    return email;
  }
};

export const deleteEmail = async function(emailId) {
  const response = await EmailRequests.deleteEmail(emailId);
  if (response && response.data && response.data.success) {
    console.log("@deleteKanban: Deleting Email successsful.");
  } else {
    console.log("@deleteKanban: Deleting Email failed.");
  }
};

const EmailHelpers = {
  createNewEmail,
  addNewBlock,
  addNewSubblock,
  deleteBlock,
  updateBlockData,
  updateBlockIndexes,
  getEmail,
  getEmailBlocks,
  getAllEmails,
  updateEmailData,
  deleteEmail,
};

export default EmailHelpers;
